import { Grid, Box } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { load, remove, save } from "../../constants/storage";
import DashboardNavbar from "../../components/DashboardNavbar";
import { H3, H4 } from "../../components/Typography";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import FlexBox from "../../components/FlexBox";
import CustomTextInput from "../../components/CustomTextInput";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
import { UPLOAD_USER_PIC } from "../../Api/EndPoints";
import * as Models from "../../models";
import { useAppDispatch } from "../../store/hooks";
import {
  updateProfilePhoto,
  getUSerInfo,
} from "../../redux/actions/UserAction";

const MyProfile: FC = () => {
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [phonenumber, setPhonNumber] = useState("");
  const [pan, setPAN] = useState("");
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDOB] = useState("");
  const [userImage, setUserImage] = useState("");
  const dispatch = useAppDispatch();

  let navigate = useNavigate();
  useEffect(() => {
    checkToken();
  }, []);
  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getUserData();
    }
  };
  const getUserData = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");

    const req = {
      id: userDetails?.id,
      mobile: userDetails?.mobile,
      partner: userDetails?.refcode,
      source: "web",
    };

    dispatch(getUSerInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }

        save("userData", JSON.stringify(response?.data[0]));
        setEmail(response?.data[0]?.email ?? "");
        setUserImage(response?.data[0]?.user_photo ?? "");
        setPhonNumber(response?.data[0]?.mobile ?? "");
        setPAN(response?.data[0]?.pan ?? "");
        setUserName(
          response?.data[0]?.firstname + " " + response?.data[0]?.lastname
        );
        setGender(response?.data[0]?.gender.toLowerCase() ?? "");
        setAddress(response?.data[0]?.line1 ?? "");
        const originalFormat = "YYYY-MM-DD"; // the format of the original string
        const formattedDateString = moment(
          response?.data[0]?.dob,
          originalFormat
        ).format("DD-MM-YYYY");
        setDOB(formattedDateString);
        save("userData", JSON.stringify(response?.data[0]));
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  // Profile Picture
  const SelectProfilePhoto = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        let userDetail: any = load("userData");
        let userDetails = JSON.parse(userDetail);
        const reader = new FileReader();

        reader.onload = function (e: any) {
          const fileContent = e.target.result.split(",")[1];
          const data: any = JSON.stringify({
            fileContent: `data:${selectedFile.type};base64,` + fileContent,
            fileName: fileContent.name,
            title: "test",
            userId: userDetails.mobile,
            description: "test",
          });

          handleUploadPhoto(data);
        };

        reader.readAsDataURL(selectedFile);
      } else {
        // Handle the case when the file is too large or no file is selected
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };
  const handleUploadPhoto = async (data: any) => {
    let token = load("token");
    setLoading(true);

    const headers = new Headers();
    if (token) {
      headers.append("Authorization", token);
      headers.append("Content-Type", "application/json");
    }

    try {
      const response: any = await fetch(UPLOAD_USER_PIC, {
        method: "POST",
        headers: headers,
        body: data,
      });
      if (response.ok) {
        const result = await response.json();

        if (result?.statusCode === 200) {
          updateProfile(result?.data?.imagePath);
          setLoading(false);
          return;
        }
      } else {
        setLoading(false);
        throw new Error("Failed to upload photo");
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };
  const updateProfile = async (profile_Id: string) => {
    setLoading(true);
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = await load("token");

    var data: Models.PROFILE_UPLOAD_REQUEST = {
      userId: userDetails?.id,
      imageUrl: profile_Id,
    };

    dispatch(updateProfilePhoto(data, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          return;
        }
        if (response?.statusCode === 200) {
          getUserData();
          toast.success(response?.message);
          return;
        } else {
          toast.error(response?.message);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  return (
    <Grid
      container
      sx={{
        background: "#F6F6F6",
        flexDirection: "column",
        display: "flex",
      }}
    >
      <DashboardNavbar userImages={userImage} />
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <Grid
            sx={{
              pl: {
                md: 8,
                xs: 2,
                sm: 2,
              },
              pr: {
                md: 8,
                xs: 2,
                sm: 2,
              },
              pb: 10,
              height: "100Vh",
              pt: 2,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              flex: 1,
            }}
          >
            <Grid
              xs={12}
              sx={{
                background: process.env.REACT_APP_PRIMARY_COLOR,
                p: 2,
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  p: 0.6,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  bottom: -95,
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    p: 0.6,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "50%",
                  }}
                >
                  <Box
                    sx={{
                      cursor: "pointer",
                      position: "relative",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <label htmlFor="image-upload">
                      <img
                        src={
                          userImage
                            ? userImage
                            : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/profilepic.svg"
                        }
                        style={{
                          height: 80,
                          width: 80,
                          borderRadius: "50%",
                        }}
                      />

                      <Box
                        sx={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "80%",
                          right: "-25%",
                          transform: "translate(-50%, -50%)",
                          background: "#fff",
                          p: 0.6,
                          borderRadius: "50%",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <CameraAltIcon
                          style={{
                            fontSize: "18px",
                            color: process.env.REACT_APP_PRIMARY_COLOR,
                          }}
                        />
                      </Box>
                    </label>
                    <input
                      accept="image/*"
                      id="image-upload"
                      type="file"
                      hidden
                      onChange={SelectProfilePhoto}
                    />
                  </Box>
                </Box>
                <H4
                  sx={{
                    mt: 1,
                  }}
                >
                  {userName}
                </H4>
              </Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              pl: {
                md: 8,
                xs: 2,
                sm: 2,
              },
              pr: {
                md: 8,
                xs: 2,
                sm: 2,
              },
            }}
          >
            <H3 sx={headingText}>Basic Details</H3>
            <FlexBox
              sx={{
                justifyContent: "space-between",
                display: "flex",
                flexDirection: {
                  md: "row",
                  xs: "column",
                },
              }}
            >
              <CustomTextInput
                title="Email Address"
                value={email}
                disabled={true}
              />
              <CustomTextInput
                title="Phone Number"
                value={phonenumber}
                disabled={true}
              />
            </FlexBox>
            <FlexBox
              sx={{
                justifyContent: "space-between",
                display: "flex",
                flexDirection: {
                  md: "row",
                  xs: "column",
                },
                mt: 1,
              }}
            >
              <CustomTextInput title="DOB" value={dob} disabled={true} />
              <CustomTextInput title="Gender" value={gender} disabled={true} />
            </FlexBox>
            <FlexBox
              sx={{
                justifyContent: "space-between",
                display: "flex",
                flexDirection: {
                  md: "row",
                  xs: "column",
                },
                mt: 1,
              }}
            >
              <CustomTextInput
                title="Address"
                value={address}
                disabled={true}
              />
              <CustomTextInput title="Pan Card" value={pan} disabled={true} />
            </FlexBox>
          </Box>
        </>
      )}
    </Grid>
  );
};

export default MyProfile;

const headingText = {
  mt: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
